import i18next from 'i18next';
import {translations} from '../../i18n/translations';

export const hoursToHoursAndMinutes = (hours: number): string => {
  // Calculate
  const rhours = Math.floor(hours);
  const minutes = (hours - rhours) * 60;
  const rminutes = Math.round(minutes);

  if (rhours !== 0 && rminutes !== 0) {
    // Go hours and minutes
    return (
      rhours +
      `${i18next.t(translations.time_units.hours)} ` +
      rminutes +
      `${i18next.t(translations.time_units.minutes)}`
    );
  } else if (rhours === 0 && rminutes !== 0) {
    // Go just minutes (because hours are zero)
    return rminutes + `${i18next.t(translations.time_units.minutes)}`;
  } else if (rhours !== 0 && rminutes === 0) {
    // Go just hours (because minutes are zero)
    return rhours + `${i18next.t(translations.time_units.hours)}`;
  } else {
    // We got nothing
    return '';
  }
};
